import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { SettingsService, TokenService, StartupService } from '../../core';
import { LogService } from '../../shared/services/log.service';
import { hasValue } from '../../shared/common-functions';
interface UserData {
    Id: number;
    unique_name: string;
    LoginId?: string; 
    UserRoleName: string;
    token: string;
}

@Component({
    selector: 'app-tokenverify',
    templateUrl: './tokenverify.html',
    standalone: false
})
export class Tokenverify implements OnInit {
    constructor(private readonly auth: AuthService,
        private readonly settings: SettingsService,
        private readonly token: TokenService,
        private readonly startup: StartupService,
        private readonly logService: LogService
    ) {

    }
    ngOnInit(): void { 
        this._loadUserData();
    }
     private async _loadUserData(): Promise<void> {
        try {
            const data: UserData = await this.auth.getUserTokens("Login");
           if (hasValue(data)) {

                const userId = data.Id;
                const userFullName = data.unique_name;
                const userEmail = data?.LoginId; // Using optional chaining for LoginId
               const UserRoleName = data.UserRoleName;
               const token = data.token;

                this.settings.setUser({
                    id: userId,
                    name: userFullName,
                    email: userEmail,
                    avatar: './assets/images/avatar.png',
                    role: data.UserRoleName,
                });

        // if (hasValue(sessionStorage.getItem('token'))) {
                   // const tokenData = sessionStorage.getItem('token');
             this.token.set({ token: token, userId, userFullName, UserRoleName });
               // }
                await this.startup.load(); 
                this.logService.setUserFullName(userFullName);
               this.logService.setUserRoleName(UserRoleName);
               sessionStorage.removeItem('usr');
               sessionStorage.removeItem('jwt');
            }
        } catch (error) {
            console.error('Error loading user data:', error);
        }
    }
}
